export const showToast = ({ type = 'success', message }) => {
  const event = new CustomEvent('SHOW_TOAST', { detail: { type, message } })
  window.dispatchEvent(event)
}
